import React from 'react';
import { Menu, MenuButton, MenuList, MenuItem, IconButton } from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon, HamburgerIcon, EditIcon } from '@chakra-ui/icons';

export default function ProductMenuAdmin({
  isAvailable,
  setUnavailable,
  setAvailable,
  id,
  isProduct,
  setMaxQuantityModal,
}) {
  return (
    <Menu>
      <MenuButton as={IconButton} aria-label='Options' icon={<HamburgerIcon />} variant='outline' />
      <MenuList>
        {isAvailable ? (
          <MenuItem
            icon={<ViewOffIcon />}
            onClick={() => {
              setUnavailable(id, isProduct);
            }}
          >
            Rendi sempre indisponibile
          </MenuItem>
        ) : (
          <MenuItem
            icon={<ViewIcon />}
            onClick={() => {
              setAvailable(id, isProduct);
            }}
          >
            Rendi sempre disponibile
          </MenuItem>
        )}
        {/* Non mostro questa opzione nel menu admin,
        per farlo dovrei inserire in Product.js il codice del modal e la chiamata alla api. 
        Ma per omogeneità in quel componente dovrei riportare tutto alla gerarchia superiore rendendo
        il file menu ancora più complicato, per ora tolgo il comando */}
        {isProduct && setMaxQuantityModal && (
          <MenuItem
            icon={<EditIcon />}
            onClick={() => {
              setMaxQuantityModal(id);
            }}
          >
            Imposta disponibilità massima
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
}
